import { render, staticRenderFns } from "./MoreInvestmentAlternativesDialog.vue?vue&type=template&id=60899314&scoped=true&"
import script from "./MoreInvestmentAlternativesDialog.vue?vue&type=script&lang=ts&"
export * from "./MoreInvestmentAlternativesDialog.vue?vue&type=script&lang=ts&"
import style0 from "./MoreInvestmentAlternativesDialog.vue?vue&type=style&index=0&id=60899314&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60899314",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardText,VCol,VContainer,VDialog,VIcon,VRow})
